module.exports = __webpack_public_path__ + "media/images/emoticons/virgo-201db523004eb8ea29e4f24ea30d8a3f.gif";